import * as Sentry from '@sentry/react'

type LogContext = Record<string, unknown>

const isDev = import.meta.env.DEV

export const logger = {
  error: (message: string, error?: unknown, context?: LogContext) => {
    if (isDev) {
      console.error(message, error, context)
    }

    if (error instanceof Error) {
      Sentry.captureException(error, {
        level: 'error',
        extra: { message, ...context },
      })
    } else if (error) {
      Sentry.captureMessage(message, {
        level: 'error',
        extra: { error, ...context },
      })
    } else {
      Sentry.captureMessage(message, {
        level: 'error',
        extra: context,
      })
    }
  },

  warn: (message: string, context?: LogContext) => {
    if (isDev) {
      console.warn(message, context)
    }

    Sentry.captureMessage(message, {
      level: 'warning',
      extra: context,
    })
  },

  info: (message: string, context?: LogContext) => {
    if (isDev) {
      console.log(message, context)
    }

    Sentry.addBreadcrumb({
      category: 'info',
      message,
      data: context,
      level: 'info',
    })
  },
}
